interface serviceId {
    serviceIdGoiKhamTongQuatCoBan: string;
    serviceIdGoiKhamTongQuatCaoCapNu: string;
    serviceIdGoiKhamTongQuatCaoCapNam: string;

    serviceIdGoiXetNghiemTongQuat: string;
    serviceIdGoiXetNghiemChuyenSauNu: string;
    serviceIdGoiXetNghiemKiemTraMenGanMoMau: string;

    serviceIdGoiXetNghiemDiTruyenToanDienDanhChoNu: string;
    serviceIdGoiXetNghiemDiTruyenKhamPhaTiemNangTriTue: string;
    serviceIdTamSoatNguyCoUngThuNuVaBenhManTinhDiTruyenCoBan: string;

    serviceIdGoiXetNghiemTamSoatUngThuNu: string;
    serviceIdGoiXetNghiemTamSoatUngThuNam: string;
    serviceIdGoiChuyenKhoaNuTamSoatUngThuCoTuCung: string;

    serviceIdCathay: string;
}

const STAGING: serviceId = {
    serviceIdGoiKhamTongQuatCoBan: '5acad0082f0631001aa0ad63',
    serviceIdGoiKhamTongQuatCaoCapNu: '5acad4122f0631001aa0ad7b',
    serviceIdGoiKhamTongQuatCaoCapNam: '5acad13f2f0631001aa0ad6e',

    serviceIdGoiXetNghiemTongQuat: '5b4c8d4da1b6ad001d5639ff',
    serviceIdGoiXetNghiemChuyenSauNu: '5e7f14da480b580012876c25',
    serviceIdGoiXetNghiemKiemTraMenGanMoMau: '5d158fd27eec570016599968',

    serviceIdGoiXetNghiemTamSoatUngThuNu: '5d158a017eec5700165998cf',
    serviceIdGoiXetNghiemTamSoatUngThuNam: '5d158a017eec5700165998cf',
    serviceIdGoiChuyenKhoaNuTamSoatUngThuCoTuCung: '5cf0ebefe26bb60015fc8894',

    serviceIdGoiXetNghiemDiTruyenToanDienDanhChoNu: '5d158a017eec5700165998cf',
    serviceIdGoiXetNghiemDiTruyenKhamPhaTiemNangTriTue: '5d158a017eec5700165998cf',
    serviceIdTamSoatNguyCoUngThuNuVaBenhManTinhDiTruyenCoBan: '5d158a017eec5700165998cf',

    serviceIdCathay: '6152889a92162b001313906a',
};

const DEVELOPMENT: serviceId = {
    serviceIdGoiKhamTongQuatCoBan: '5acad0082f0631001aa0ad63',
    serviceIdGoiKhamTongQuatCaoCapNu: '5acad4122f0631001aa0ad7b',
    serviceIdGoiKhamTongQuatCaoCapNam: '5acad13f2f0631001aa0ad6e',

    serviceIdGoiXetNghiemTongQuat: '5b4c8d4da1b6ad001d5639ff',
    serviceIdGoiXetNghiemChuyenSauNu: '5e7f14da480b580012876c25',
    serviceIdGoiXetNghiemKiemTraMenGanMoMau: '5d158fd27eec570016599968',

    serviceIdGoiXetNghiemTamSoatUngThuNu: '5d158a017eec5700165998cf',
    serviceIdGoiXetNghiemTamSoatUngThuNam: '5d158a017eec5700165998cf',
    serviceIdGoiChuyenKhoaNuTamSoatUngThuCoTuCung: '5cf0ebefe26bb60015fc8894',

    serviceIdGoiXetNghiemDiTruyenToanDienDanhChoNu: '5d158a017eec5700165998cf',
    serviceIdGoiXetNghiemDiTruyenKhamPhaTiemNangTriTue: '5d158a017eec5700165998cf',
    serviceIdTamSoatNguyCoUngThuNuVaBenhManTinhDiTruyenCoBan: '5d158a017eec5700165998cf',

    serviceIdCathay: '6152889a92162b001313906a',
};

// use on app
const PRODUCTION: serviceId = {
    serviceIdGoiKhamTongQuatCoBan: '5acad0082f0631001aa0ad63',
    serviceIdGoiKhamTongQuatCaoCapNu: '5f866b2d795e4f0013750bb0',
    serviceIdGoiKhamTongQuatCaoCapNam: '5f866e9d85d82a00126428f9',

    serviceIdGoiXetNghiemTongQuat: '5b4c8d4da1b6ad001d5639ff',
    serviceIdGoiXetNghiemChuyenSauNu: '5f8665e2795e4f00137506e5',
    serviceIdGoiXetNghiemKiemTraMenGanMoMau: '601b5eb73dd9ed0012135da6',

    serviceIdGoiXetNghiemTamSoatUngThuNu: '5a3709cbf0fbf0001b887deb',
    serviceIdGoiXetNghiemTamSoatUngThuNam: '5a370b6cf0fbf0001b887df1',
    serviceIdGoiChuyenKhoaNuTamSoatUngThuCoTuCung: '5c91b2ffdf184b00186f1322',

    serviceIdGoiXetNghiemDiTruyenToanDienDanhChoNu: '5f86d47b9efc630013a2de79',
    serviceIdGoiXetNghiemDiTruyenKhamPhaTiemNangTriTue: '5f86acab12d0100012100151',
    serviceIdTamSoatNguyCoUngThuNuVaBenhManTinhDiTruyenCoBan: '5f86c92e9efc630013a2d3ef',

    serviceIdCathay: '6152889a92162b001313906a',
};

export default ((nodeEnv: string) => {
    switch (nodeEnv) {
        case 'production':
            return PRODUCTION;
        case 'develop':
            return DEVELOPMENT;
        case 'staging':
            return STAGING;
        default:
            return PRODUCTION;
    }
})(process.env.RUN_ENV);
